import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getAnalytics, logEvent } from 'firebase/analytics';

// Your Firebase configuration
const app = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
});

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

export const functions = getFunctions(app);
export const analytics = getAnalytics(app);
export { logEvent };

/**
 * Returns true if the given email should be excluded from analytics tracking.
 * Excluded emails: the owner test account and any sub-addressed "+test" addresses.
 */
export const isAnalyticsExcludedEmail = (email: string | null | undefined): boolean => {
  if (!email) return false;
  if (email === 'jaymichls@gmail.com') return true;
  // Match any email with +test before the @ sign (e.g. user+test@example.com)
  const atIndex = email.indexOf('@');
  if (atIndex === -1) return false;
  const local = email.slice(0, atIndex);
  return local.includes('+test');
};

/** Track a named event in Firebase Analytics. Use this on every button click and primary action. */
export const trackEvent = (name: string, params?: Record<string, unknown>): void => {
  if (isAnalyticsExcludedEmail(auth.currentUser?.email)) return;
  logEvent(analytics, name, params ?? {});
};

export default app;

// Check if we are running in the emulator environment
if (import.meta.env.DEV) {
  // Connect to the Auth emulator
  connectAuthEmulator(auth, 'http://localhost:9099');

  // Connect to the Functions emulator
  connectFunctionsEmulator(functions, 'localhost', 5001);

  // Connect to the Firestore emulator
  connectFirestoreEmulator(db, 'localhost', 8080);
}
